import type { TimelineEvent } from "@/types/content";
import StatusBadge from "@/components/base/StatusBadge";

export default function TimelineNode({
  event,
  isLast = false,
}: {
  event: TimelineEvent;
  isLast?: boolean;
}) {
  return (
    <li className="relative flex gap-4 pb-6 last:pb-0 md:gap-6">
      <div className="flex flex-col items-center">
        <span className="mt-1 flex h-3.5 w-3.5 shrink-0 items-center justify-center rounded-full border-2 border-primary-500 bg-background-50">
          <span className="h-1.5 w-1.5 rounded-full bg-primary-500"></span>
        </span>
        {!isLast && <span className="mt-1 w-px flex-1 bg-background-300"></span>}
      </div>

      <div className="flex-1 pb-1">
        <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
          <span className="font-heading text-sm font-bold text-foreground-950">
            {event.date}
          </span>
          <span className="whitespace-nowrap rounded bg-secondary-100 px-1.5 py-0.5 text-[11px] text-secondary-900">
            {event.time}
          </span>
          <StatusBadge status={event.status} size="sm" />
        </div>
        <h3 className="mt-2 font-heading text-base font-semibold text-foreground-950">
          {event.title}
        </h3>
        <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">
          {event.summary}
        </p>
        <div className="mt-2.5 flex flex-wrap gap-2">
          {event.sources.map((source) => (
            <span
              key={source}
              className="inline-flex items-center gap-1 whitespace-nowrap rounded border border-background-300 bg-background-50 px-2 py-0.5 text-[11px] text-foreground-500"
            >
              <span className="flex h-3 w-3 items-center justify-center">
                <i className="ri-link text-xs"></i>
              </span>
              {source}
            </span>
          ))}
        </div>
      </div>
    </li>
  );
}